import { IconButton } from '@/components/Buttons';
import { Helmet } from "@/components/Helmet";
import { NoContextImage } from '@/components/Image';
import { View } from '@/components/Theme';
import { StyleSheet } from 'react-native';

const CarouselImage = (props) => {
    
    const {
        path, 
        dimension, 
        thumbnails, 
        thumbnailStyle, 
        showPlus,
        title = 'Produktbild',
        alternativeText = null
    } = props;

    return (
        <View style={styles.videoWrapper}>
            
            <Helmet>
                <link rel="preload" fetchpriority="high" href={path} as="image" type="image/webp" />
            </Helmet>

            <NoContextImage 
                source={{uri: path}}
                resizeMethod={'resize'}
                fallback={true}
                fallbackSource={{uri: path}}    
                contentFit={thumbnails ? 'cover' : 'contain'}
                width={dimension?.width}
                height={dimension?.height} 
                style={[styles.imageStyle, {width: dimension?.width, height: dimension?.height}, thumbnailStyle]} 
                priority="high"
                accessibilityLabel={alternativeText ?? title ?? 'Produktbild'}
                accessibilityRole="image"
            />

            {showPlus && 
                <View style={styles.plus}>
                    <IconButton icon={'circle-plus'} size={20} style={styles.plusIcon} color={'black'} />
                </View>
            }
        </View>
    );

};

const styles = StyleSheet.create({
    videoWrapper: {
        position: 'relative', 
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    videoPlay: {
        zIndex: 99, 
        position: 'absolute', 
        alignSelf: 'center', 
        marginTop: -25,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 100,  
    },
    plus: {
        zIndex: 99, 
        position: 'absolute', 
        alignSelf: 'center', 
        justifyContent: 'center',
        alignItems: 'center',
        
        width: 30,
        height: 30,
        right: 5,
        bottom: 5,
        borderRadius: 100,  
        opacity: .9
    },
    plusIcon: {
        color:'white'
    },
    videoPlayIcon: {
        color:'white'
    },
    imageStyle: {
        justifyContent: 'center', 
        alignItems: 'center'
    }
});

export default CarouselImage;